import React from 'react';
import { getPasswordStrength } from '../utils/passwordValidation';

const PasswordStrengthMeter = ({ password }) => {
    const { score, label, color } = getPasswordStrength(password);
    if (!password) return null;

    return (
        <div style={{ marginTop: '4px' }}>
            <div style={{ display: 'flex', gap: '4px', marginBottom: '2px' }}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <div
                        key={i}
                        style={{
                            flex: 1,
                            height: '4px',
                            borderRadius: '2px',
                            backgroundColor: i <= score ? color : '#dee2e6',
                            transition: 'background-color 0.2s',
                        }}
                    />
                ))}
            </div>
            {label && (
                <span style={{ fontSize: '11px', color, fontWeight: 600 }}>{label}</span>
            )}
        </div>
    );
};

export default PasswordStrengthMeter;
